import { ActiveStates } from './Types/ActiveStates'

const initPreferences = () => {
  document.querySelector('.cookiebanner__toggle')
    .addEventListener('click', (e: Event): void => {
      e.stopPropagation()

      document.querySelector('.cookiebanner__content-wrapper').classList.toggle(ActiveStates.Hidden)
      document.querySelector('.preferences').classList.toggle(ActiveStates.Active)
      document.querySelector('.cookiebanner__buttons').classList.toggle(ActiveStates.Hidden)
      document.querySelector('.cookiebanner__pref-buttons').classList.toggle(ActiveStates.Active)
    })
}

export default initPreferences
